"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableLoadingPanel = void 0;
var react_1 = __importDefault(require("react"));
var __1 = require("../");
var internal_1 = require("../../internal");
var TableLoadingPanel = function (_a) {
    var portal = _a.portal;
    var loadingPanel = (react_1.default.createElement("div", { className: "k-loading-mask" },
        react_1.default.createElement(__1.Stack, { alignItems: "center", justifyContent: "center", className: "h-100" },
            react_1.default.createElement(__1.Spinner, null)),
        react_1.default.createElement("div", { className: "k-loading-color" })));
    return (react_1.default.createElement(internal_1.Portal, { conditional: !!portal, target: typeof portal !== 'boolean' ? portal : undefined }, loadingPanel));
};
exports.TableLoadingPanel = TableLoadingPanel;
//# sourceMappingURL=TableLoadingPanel.js.map